import { Component, OnInit, HostListener } from '@angular/core';
import { OfferService } from './offers.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-free-resourse',
    templateUrl: './free-resourse.component.html',
    styleUrls: ['./free-resourse.component.css'],
    standalone: false
})
export class FreeResourseComponent implements OnInit {

  allOffers: any[] = [];
  loading: boolean = false;
  error: string = null;
  sub: Subscription;

  // Category System
  categories: string[] = [];
  activeCategory: string = "all";

  constructor(
    private offerService: OfferService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadOffers();
  }

  ngOnDestroy() {
    if (this.sub) this.sub.unsubscribe();
  }

  loadOffers() {
    this.loading = true;
    this.error = null;

    this.sub = this.offerService.getAllOffers().subscribe(
      (res: any) => {
        let arr: any[] = [];

        if (res && res.data && Array.isArray(res.data)) {
          arr = res.data;
        } else if (Array.isArray(res)) {
          arr = res;
        }

        this.allOffers = arr.reverse();

        this.categories = ['all'];
        this.allOffers.forEach(function(o) {
          if (o.category && o.category.trim() !== '') {
            const cat = o.category.toLowerCase();
            if (this.categories.indexOf(cat) === -1) {
              this.categories.push(cat);
            }
          }
        }.bind(this));

        this.loading = false;
      },
      (err) => {
        console.error('Error loading offers', err);
        this.error = "Failed to load offers. Try again later.";
        this.loading = false;
      }
    );
  }

  get filteredOffers() {
    if (!this.allOffers.length) return [];
    if (this.activeCategory === 'all') {
      return this.allOffers;
    }
    return this.allOffers.filter(function(o) {
      return (o.category || '').toLowerCase() === this.activeCategory.toLowerCase();
    }.bind(this));
  }

  setCategory(cat: string) {
    this.activeCategory = cat;
  }

  onImageClick(o: any) {
    const link = o.page_link || o.pageLink;
    if (!link) return;

    if (link.indexOf('/') === 0) {
      this.router.navigateByUrl(link);
    } else {
      window.open(link, "_blank");
    }
  }

  imageSrc(o: any): string {
    if (o && o.image) return o.image;
    return "assets/images/default-offer.png";
  }


  // Dropdown toggle support (future filtering UI)
  classDropdownOpen: boolean = false;
  boardDropdownOpen: boolean = false;
  yearDropdownOpen: boolean = false;
  typeDropdownOpen: boolean = false;

  @HostListener("document:click", ["$event"])
  onOutsideClick(event: MouseEvent) {
    const el = event.target as HTMLElement;
    if (!el.closest || !el.closest('.custom-dropdown')) {
      this.classDropdownOpen =
      this.boardDropdownOpen =
      this.yearDropdownOpen =
      this.typeDropdownOpen = false;
    }
  }

  heroImage(): string {
  if (this.allOffers && this.allOffers.length) {
    const lastOffer = this.allOffers[this.allOffers.length - 1];
    return this.imageSrc(lastOffer);
  }
  return 'assets/images/hero-education.jpg'; // fallback image
}

scrollToOffers() {
  const element = document.getElementById('offers-list');
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

  // old actions for existing UX
  bookSlot(): void {
    window.location.href = 'https://www.sehyog.co.uk/11plus-help-club/category/workshop/5a96224a84937ec99f53ef8055c4b81d';
  }

  openQuestionBank(): void {
    window.location.href = 'https://www.sehyog.co.uk/11plus-help-club/category/offers';
  }
}